// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2y5MB","vLegacy":"SelectSecondary_vLegacy__3-Bux","error":"SelectSecondary_error__2fEMQ","disabled":"SelectSecondary_disabled__18Lpd"};